import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as DropdownArrow } from './dropdown-arrow.svg';

const Dropdown = (props) => {
    const { className, options, ...htmlProps } = props;
    const classNames = ['fs-dropdown', className].filter(Boolean).join(' ');
    return (
        <div className={classNames}>
            <select {...htmlProps}>
                {options.map((opt, i) => (
                    <option key={`${i}-${opt.name}`} value={opt.value}>
                        {opt.name}
                    </option>
                ))}
            </select>
            <DropdownArrow />
        </div>
    );
};

Dropdown.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.exact({
            name: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired
    ).isRequired,
};

export default Dropdown;
